export const PosEndpoints = {
    catalog: () => '/pos/catalog',
};
